import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    padding: '16px',
    gap: '5px',
    border: '2px dashed rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgba(241, 245, 249, 1)',
    cursor: 'pointer',

    '&:hover': {
      border: '2px solid rgba(0, 0, 0, 0.12)',
    }
  },
  title: {
    fontWeight: 400,
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 1)',
  },
  titleRemark: {
    fontWeight: 400,
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.6)',
    marginBottom: '15px',
  },
  titleValidation: {
    fontWeight: 400,
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.38)'
  },
  input: {
    display: 'none',
  },
  error: {
    color: 'red',
  }
}))


